import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";
import ptTranslation from "./locales/pt/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
};

const SUPPORTED_LANGUAGES = ["en", "es", "pt"];

// Get browser language with fallback
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split("-")[0];
  return SUPPORTED_LANGUAGES.includes(langCode) ? langCode : "en";
};

// Priority: ?lang= URL param > localStorage > browser language
const initializeLanguage = () => {
  // 1. URL param (passed by host apps like userAdmin-fe)
  const urlLang = new URLSearchParams(window.location.search).get("lang");
  if (urlLang && SUPPORTED_LANGUAGES.includes(urlLang)) {
    localStorage.setItem("submodule_i18nextLng", urlLang);
    return urlLang;
  }

  // 2. Previously saved language
  const storedLang = localStorage.getItem("submodule_i18nextLng");
  if (storedLang && SUPPORTED_LANGUAGES.includes(storedLang)) {
    return storedLang;
  }

  // 3. Browser language
  const browserLang = getBrowserLanguage();
  localStorage.setItem("submodule_i18nextLng", browserLang);
  return browserLang;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initializeLanguage(),
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Persist language changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("submodule_i18nextLng", lng);
});

// Public API for external language changes (e.g. from host app header)
window.setSubmoduleLanguage = (language) => {
  if (SUPPORTED_LANGUAGES.includes(language) && i18n.language !== language) {
    i18n.changeLanguage(language);
  }
};

export default i18n;
